import { render, staticRenderFns } from "./TableCustomer.vue?vue&type=template&id=9de2d9f2&"
import script from "./TableCustomer.vue?vue&type=script&lang=js&"
export * from "./TableCustomer.vue?vue&type=script&lang=js&"
import style0 from "./TableCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports